import axios from "axios";

export const login = (email, password, code, recaptcha) => {
  return axios.post("auth/login", { email, password, code, recaptcha }).catch(error => {
    throw error.response;
  });
};

export const logout = () => {
  return axios.post("auth/logout").catch(error => {
    throw error.response;
  });
};

export const refreshToken = refreshToken => {
  return axios
    .put(
      "auth/refresh-token",
      {},
      {
        headers: {
          "X-SkipVerifyToken": true,
          "X-RefreshToken": true,
          Authorization: "Bearer " + refreshToken
        }
      }
    )
    .catch(error => {
      throw error.response;
    });
};

export const getSession = token => {
  return axios
    .get(
      "auth/session",
      { params: { token } },
      {
        headers: {
          "X-SkipVerifyToken": true
        }
      }
    )
    .catch(error => {
      throw error.response;
    });
};

export const sendPasswordReset = (request) => {
  return axios
    .post(
      `auth/reset-password/${request.email}`,
      {
        recaptcha: request.recaptcha
      },
      {
        headers: {
          "X-SkipVerifyToken": true
        }
      }
    )
    .catch(error => {
      throw error.response;
    });
};

export const resetPassword = request => {
  const { id } = request;

  return axios
    .post(`auth/reset-password/${id}`, request, {
      headers: {
        "X-SkipVerifyToken": true
      }
    })
    .catch(error => {
      throw error.response;
    });
};
